import capitalize from 'lodash/capitalize';
import { ContentDetailsFragment } from '../../graphql/types';

const getVideoContent = (content?: ContentDetailsFragment | null) =>
  content?.__typename === 'Video' ? content : null;

const getAudioContent = (content?: ContentDetailsFragment | null) =>
  content?.__typename === 'Audio' ? content : null;

const getArticleContent = (content?: ContentDetailsFragment | null) =>
  content?.__typename === 'Article' ? content : null;

export const getOnDemandContent = (content?: ContentDetailsFragment | null) =>
  getVideoContent(content) ||
  getAudioContent(content) ||
  getArticleContent(content);

export const getAudioVideoContent = (content?: ContentDetailsFragment | null) =>
  getVideoContent(content) || getAudioContent(content);

export const getComponentFromFormat = (formats: string[]) => {
  const components: string[] = [];
  if (formats.includes('video')) {
    components.push('view-ondemand-class');
  }
  if (formats.includes('audio')) {
    components.push('view-ondemand-audio-class');
  }
  if (formats.includes('article')) {
    components.push('view-ondemand-article');
  }

  return components.join(',');
};

export const cleanUpBrand = (brand: string) =>
  brand.replace('_', ' ').split(' ').map(capitalize).join(' ');
